// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3-kkN","item":"PaymentsMobile_item__2ZVZl","label":"PaymentsMobile_label__3jL_4","amount":"PaymentsMobile_amount__1chxr"};